import React from 'react';
import OnboardingSection from '../OnboardingSection';

type OnboardingAboutMeProps = {
  onEdit: () => void;
};

const OnboardingAboutMe: React.FCWithChildren<OnboardingAboutMeProps> = ({
  onEdit,
}) => (
  <OnboardingSection
    onClick={onEdit}
    label="Tell clients a little bit about yourself"
    testID="editAboutMeLink"
  />
);

export default OnboardingAboutMe;
